import { useRouter } from 'next/router';
import { useState } from 'react';
import Button from '~/components/common/button';
import Loading from '~/components/common/loaders/loader';
import { Translate } from '~/i18n';
import Axios from '~/utils/axios';
// import { ReviewsBox } from './reviews-box';
import { SingleReview } from './single-review';
import { sentryCaptureException } from '~/errors/sentry';

export interface ExperienceReviewsProps {
   reviews: {
      reviews: any[];
      overall_rating?: number;
      experience_rating?: number;
      organizer_rating?: number;
      venue_rating?: number;
      price_rating?: number;
      total: number;
      last_page: number;
      curr_page: number;
      experience_id: string;
   };
}
const ExperienceReviews = ({ reviews: r }: ExperienceReviewsProps) => {
   const [data, setData] = useState(r);
   const [loading, setLoading] = useState(false);
   const { query } = useRouter();

   const loadMore = async () => {
      try {
         setLoading(true);
         const { data: response } = await Axios.get(
            `venues/${data.experience_id}/reviews?perpage=5&page=${data.curr_page + 1}&lang=${
               query.lang
            }`
         );
         const result = response.data;
         setData(prev => ({
            ...prev,
            curr_page: result.curr_page,
            reviews: [...prev.reviews, ...result.reviews],
         }));
      } catch (error) {
         sentryCaptureException(error);
      }
      setLoading(false);
   };

   return (
      <div id="reviews" className="relative no-anchor">
         <div>
            <div className="flex flex-wrap">
               <div className="w-full lg:w-3/4 lg:mt-10">
                  {data.reviews.map((review, idx) => (
                     <div key={idx}>
                        <SingleReview {...review} />
                        {data.reviews.length !== idx + 1 && <hr className="mb-2" />}
                     </div>
                  ))}

                  {data.curr_page >= data.last_page ? null : (
                     <Button
                        type="secondary"
                        disabled={loading}
                        className="px-6 mb-8 font-bold border-gray-300"
                        onClick={loadMore}>
                        {loading ? (
                           <Loading color="black" size={24} />
                        ) : (
                           <Translate
                              id="common:show more remaining"
                              values={{
                                 remaining: String(Math.max(data.total - data.reviews.length, 0)),
                              }}
                           />
                        )}
                     </Button>
                  )}
               </div>
            </div>
            {/* {!!reviews.length && reviews.length < data.total && ( */}

            {/* )} */}
         </div>
      </div>
   );
};

export default ExperienceReviews;
